export interface IStatusFilterOption {
  value: string;
  label: string;
}

export const STATUS_FILTER_OPTIONS: IStatusFilterOption[] = [
  { value: 'OPENED', label: 'Aberta' },
  { value: 'PENDING', label: 'Aguardando' },
  { value: 'CLOSED', label: 'Fechada' },
];
